import React from "react"
import type { CMSPageProps } from "packages/acquisition/components/chakra-components/LandingPage/LandingPage.utils"
import type {
  LivePromoTileType,
  PromoTilesContainer as PromoTilesContainerType,
  PromoTile as PromoTileType,
} from "types/cms"
import { PromoTile } from "./PromoTile"

import { outerContainer, innerContainer, innerGrid } from "./PromoTiles.css"
import { LivePromoTile } from "./LivePromoTile"

type Props = CMSPageProps & PromoTilesContainerType

export const PromoTiles: React.FC<Props> = ({ promoTiles, trackingModule }) => (
  <div className={outerContainer}>
    <div className={innerContainer}>
      <div className={innerGrid} data-testid="HomeImageGrid">
        {promoTiles.map((item) => {
          if (
            (item as LivePromoTileType).__typename === "LivePromoTile" ||
            (item as LivePromoTileType).contentBlocks
          ) {
            return (
              <LivePromoTile
                key={item.id}
                {...(item as LivePromoTileType)}
                trackingModule={trackingModule}
              />
            )
          }
          return (
            <PromoTile
              key={item.id}
              {...(item as PromoTileType)}
              trackingModule={trackingModule}
            />
          )
        })}
      </div>
    </div>
  </div>
)
